import { DragDropContext, Droppable } from 'react-beautiful-dnd';

import BlogColEdition from './BlogColEdition';

import { simpleConfirmDialog } from '../../../../actions/swal_msg';

import {
    Grid, Card, Alert, Divider, Chip
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const BlogRowEdition = ({ setOpen, row, setRow, oldFiles, setOldFiles }) => {

    // bloque movido de posición
    const onDragEnd = (result, row, setRow) => {
        if (!result.destination) return;
        const { source, destination } = result;
        if (source.droppableId !== destination.droppableId) {
            const sourceColumn = row.find(e => e.id === source.droppableId);
            const i = sourceColumn ? row.findIndex(e => e.id === source.droppableId) : 0;

            const destColumn = row.find(e => e.id === destination.droppableId);
            const j = destColumn ? row.findIndex(e => e.id === destination.droppableId) : 0;

            const sourceItems = sourceColumn ? [...sourceColumn.col] : [];
            const destItems = destColumn ? [...destColumn.col] : [];
            const [removed] = sourceItems.splice(source.index, 1);
            destItems.splice(destination.index, 0, removed);

            let content = [...row];
            content[i] = { ...content[i], col: sourceItems };
            content[j] = { ...content[j], col: destItems };
            setRow(content);
        } else {
            const column = row.find(e => e.id === source.droppableId);
            const i = column ? row.findIndex(e => e.id === source.droppableId) : 0;
            const copiedItems = column ? [...column.col] : [];
            const [removed] = copiedItems.splice(source.index, 1);
            copiedItems.splice(destination.index, 0, removed);
            let content = [...row];
            content[i] = { ...content[i], col: copiedItems };
            setRow(content);
        }
    };

    const handleDelete = (row_index, col_length) => async () => {
        const txt = `¿Desea eliminar la fila #${row_index+1}?${col_length > 0 ? ` Se eliminarán ${col_length} bloques` : ''}`;
        if (await simpleConfirmDialog(txt, 'Sí, continuar')) {
            setRow(e => e.filter((e_row, i) => i !== row_index));
        }
    };

    return (
        <DragDropContext
            onDragEnd={ (result) => onDragEnd(result, row, setRow) }>
            <Card sx={{ mb: 2, boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)' }}>
                {
                    row.map(({ col, id }, i) => {
                        return (
                            <Droppable key={id} droppableId={id}
                                direction="horizontal">
                                {(provided, snapshot) => (
                                    <Grid container spacing={2} my={5} px={2}
                                        ref={ provided.innerRef }
                                        { ...provided.droppableProps }>
                                        <Grid item xs={12}>
                                            <Divider>
                                                <Chip label={`Fila ${i+1}`} variant="outlined"
                                                    onDelete={handleDelete(i, col.length)}
                                                    deleteIcon={<DeleteOutlineIcon /> }
                                                />
                                            </Divider>
                                        </Grid>
                                        {
                                            col.length > 0 ?
                                                col.map((block, j) =>
                                                    <BlogColEdition
                                                        key={block.id}
                                                        col_index={j}
                                                        row_index={i}
                                                        col={block}
                                                        setOpen={ setOpen } 
                                                        row={row}
                                                        setRow={setRow}
                                                        oldFiles={oldFiles}
                                                        setOldFiles={setOldFiles}
                                                    />
                                                )
                                            :
                                                <Grid item xs={12}>
                                                    <Alert severity="info">No hay bloques en la fila</Alert>
                                                </Grid>
                                        }
                                        { provided.placeholder }
                                    </Grid>
                                )}
                            </Droppable>
                        )
                    })
                }
            </Card>
        </DragDropContext>
    );
};

export default BlogRowEdition;